import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {
  normalizeWorldCupPickHomepageResponse,
  type WorldCupPickHomepageResponse,
  EMPTY_WORLD_CUP_PICK_HOMEPAGE,
  WORLD_CUP_PICK_SORT_TYPE,
  type NormalizedWorldCupPickHomepageData,
} from './pages/world-cup-champion-predict/api'

export const world_cup_pick_homepage = createAsyncThunk(
  'WorldCup/world_cup_pick_homepage',
  async (arg: {sort_type?: number}) => {
    const sortType = arg?.sort_type ?? WORLD_CUP_PICK_SORT_TYPE.hotTeam
    const resp = await http.post<{data: WorldCupPickHomepageResponse}>(
      '/live/activity/world_cup_pick_homepage',
      {sort_type: sortType},
      {store: window.store}
    )
    return normalizeWorldCupPickHomepageResponse(resp.data.data)
  }
)

interface WorldCupState {
  homepage: NormalizedWorldCupPickHomepageData
  sort_type: number
  loaded: boolean
}

const initialState: WorldCupState = {
  homepage: EMPTY_WORLD_CUP_PICK_HOMEPAGE,
  sort_type: WORLD_CUP_PICK_SORT_TYPE.hotTeam,
  loaded: false,
}

export const WorldCupSlice = createSlice({
  name: 'WorldCup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(world_cup_pick_homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        homepage: action.payload,
        loaded: true,
      })
    })
    builder.addCase(world_cup_pick_homepage.pending, (state, action) => {
      const sortType = action.meta.arg?.sort_type
      if (sortType != null) {
        Object.assign(state, {
          sort_type: sortType,
        })
      }
    })
  },
})

export default WorldCupSlice.reducer
